import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./CreateNewRestaurantPage.css";
import TimeRangeSelector from "../../Components/TimeRangeSelector/TimeRangeSelector";
import CharacterLimitedTextArea from "../../Components/CharacterLimitedTextArea/CharacterLimitedTextArea";
import {
  Button,
  ConfigProvider,
  Divider,
  message,
  Segmented,
  Form,
  Input,
  Alert,
  Flex,
  Typography,
  Steps
} from "antd";
import Characteristics from "../../Components/Characteristics/characteristics";
import {
  CharacteristicsService,
  RestaurantService,
  TokenService,
} from "deliziora-client-module/client-web";
import { InfoCircleOutlined, UserOutlined, ShopOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from "react-redux";
import {
  updateHoursWorking,
  addRestaurant,
} from "../../features/restaurant/restaurantFeature";
import UploadImages from "../../Components/UploadImages/Upload";
import GoogleMap from "../../Components/Map/Map";
import { useParams } from 'react-router-dom';
import { isMobile } from "react-device-detect";
import { useAuth0 } from "@auth0/auth0-react";
import { GoogleLoginButton, FacebookLoginButton } from 'react-social-login-buttons';

export default function CreateNewRestaurantPage() {
  const { uuid } = useParams();
  const navigate = useNavigate();
  const restaurant = JSON.parse(localStorage.getItem("userData"));
  const restaurantRedux = useSelector((state) => state.restaurant);
  const selectedDay = useRef("Segunda");
  const [form] = Form.useForm();
  const [images, setImages] = useState("");
  const [fileList, setFileList] = useState([]);
  const [clickedLocation, setClickedLocation] = useState(null);
  const [characteristics, setCharacteristics] = useState([]);
  const [description, setDescription] = useState("");

  const { loginWithPopup, loginWithRedirect } = useAuth0();

  // Estado para controlar os steps
  const [currentStep, setCurrentStep] = useState(0);

  const [characteristicsSelected, setCharacteristicsSelected] = useState([]);
  const [selectedDaySegmented, setSelectedDaySegmented] = useState("monday");
  const [newOpeningClosingTimes, setNewOpeningClosingTimes] = useState(null);
  const [tokens, setTokens] = useState({})
  const [isnewOpeningClosingTimes, setisNewOpeningClosingTimes] =
    useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    CharacteristicsService.returnAllCharacteristics()
      .then((res) => {
        setCharacteristics(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    if (newOpeningClosingTimes) {
      setisNewOpeningClosingTimes(true);
    } else {
      setisNewOpeningClosingTimes(false);
    }
    console.log(isnewOpeningClosingTimes);
  }, [newOpeningClosingTimes, isnewOpeningClosingTimes, selectedDaySegmented]);
  const handleSegmentedChange = (option) => {
    const dayToKeyMap = {
      Segunda: "monday",
      Terça: "tuesday",
      Quarta: "wednesday",
      Quinta: "thursday",
      Sexta: "friday",
      Sábado: "saturday",
      Domingo: "sunday",
    };
    const selectedDayKey = dayToKeyMap[option];
    if (selectedDayKey) {
      selectedDay.current = option;
      setSelectedDaySegmented(selectedDayKey);
    }
  };
  const handleClickCharacteristics = (idChar) => {
    if (characteristicsSelected.includes(idChar)) {
      setCharacteristicsSelected((prevSelected) =>
        prevSelected.filter((id) => id !== idChar)
      );
    } else {
      setCharacteristicsSelected((prevSelected) => [...prevSelected, idChar]);
    }
  };
  const updateTimesForDay = (day, opening, closing) => {
    const dayToKeyMap = {
      monday: "monday",
      tuesday: "tuesday",
      wednesday: "wednesday",
      thursday: "thursday",
      friday: "friday",
      saturday: "saturday",
      sunday: "sunday",
    };
    const dayKey = dayToKeyMap[day];
    if (dayKey) {
      dispatch(
        updateHoursWorking({
          [dayKey]: {
            open: opening,
            closed: closing,
          },
        })
      );
    }
  };
  const saveModifications = () => {
    form.submit();
    const restaurant = form.getFieldsValue();
    console.log(clickedLocation);
    console.log({
      name: restaurant.name,
      address: restaurant.address,
      latitude: String(clickedLocation.lat),
      especialty: "",
      complete_menu: false,
      password: restaurant.password,
      email: restaurant.email,
      longitude: String(clickedLocation.lng),
      opening_hours: restaurantRedux.opening_hours,
      contact: restaurant.contact,
      description: description,
      img: images,
      categories: [],
      characteristics: characteristicsSelected,
      created_at: "",
    });
    RestaurantService.addNewRestaurant({
      name: restaurant.name,
      address: restaurant.address,
      latitude: String(clickedLocation.lat),
      especialty: "",
      complete_menu: false,
      password: restaurant.password,
      email: restaurant.email,
      longitude: String(clickedLocation.lng),
      opening_hours: restaurantRedux.opening_hours,
      contact: restaurant.contact,
      description: description,
      img: images,
      categories: [],
      characteristics: characteristicsSelected,
      created_at: "",
    })
      .then((res) => {
        message.success("Restaurante guardado com sucesso! Agora vincule sua conta.");
        setCurrentStep(1); // Avança para o step de vinculação
        setInterval(() => {
          RestaurantService.returnRestaurantById(res.data)
            .then((res) => {
              localStorage.setItem("userData", JSON.stringify(res.data));
              // navigate("/home");
              // window.location.reload()
            })
            .catch((err) => {
              console.error(err);
            });
        }, 1000);
      })
      .catch((err) => {
        message.error("Por Favor verificar os dados inseridos");
        console.error(err);
      });
  };
  function getTimeOfRestaurantRedux(day) {
    switch (day) {
      case "monday":
        return restaurantRedux.opening_hours.monday;
      case "tuesday":
        return restaurantRedux.opening_hours.tuesday;
      case "wednesday":
        return restaurantRedux.opening_hours.wednesday;
      case "thursday":
        return restaurantRedux.opening_hours.thursday;
      case "friday":
        return restaurantRedux.opening_hours.friday;
      case "saturday":
        return restaurantRedux.opening_hours.saturday;
      case "sunday":
        return restaurantRedux.opening_hours.sunday;
      default:
        break;
    }
  }
  const handleDataReceivedImages = (values) => {
    setImages(values);
    console.log(images);
  };
  const onFinish = (values) => {
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Falha no envio do formulário:", errorInfo);

  };

  const loginGoogle = async () => {
    try {
      await loginWithRedirect({
        appState: {
          returnTo: `/create-restaurant/${uuid}`,
        }
      });
    } catch (err) {
      console.error('Erro ao fazer login com Google:', err);
    }
  };

  const getRestaurantInfomation = () => {
    // if cotains parameter restaurantId on the URL, then get the restaurant information
    const params = new URLSearchParams(window.location.search);
    const restaurantId = params.get('restaurantId');
    if (restaurantId) {
      RestaurantService.returnRestaurantById(restaurantId)
        .then((res) => {
          form.setFieldsValue(res.data)
          setClickedLocation({
            lat: res.data.latitude,
            lng: res.data.longitude
          });
          setDescription(res.data.description || "");
        })
        .catch((err) => {
          console.error("Erro ao obter informações do restaurante:", err);
          alert("Erro ao obter informações do restaurante. Por favor, verifique o ID do restaurante.");
        });
    } else {
      alert("Nenhum ID de restaurante fornecido na URL.");
    }
  }

  const alreadyRestaurantInformation = useRef(false);

  useEffect(() => {
    if (!alreadyRestaurantInformation.current) {
      getRestaurantInfomation();
      alreadyRestaurantInformation.current = true;
    }
  }, []);

  // Componente para Step 1: Dados do Restaurante
  const RestaurantDataStep = () => (
    <>
      <Flex>
        {isMobile === true ?
          <Flex vertical align="center" justify="center">
            <Typography.Title level={4}>
              Cadastro de Restaurante
            </Typography.Title>
            <Flex vertical style={
              {
                maxWidth: "90%",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "16px",
                margin: "16px",
                backgroundColor: "#fff",
                display: "flex",
              }
            }>
              <Alert
                description="Se porventura sair da página ou atualizar, o token para criar um restaurante será invalidado. Por conseguinte, solicite um novo token se necessário."
                type="warning"
                showIcon
                style={{ marginBottom: '16px' }}
              />
              <h3>Logo do Restaurante</h3>
              <UploadImages
                onDataReceived={handleDataReceivedImages}
                setImagesList={setImages}
                fileList={fileList}
                setFileList={setFileList}
              />
              <Form
                form={form}
                name="form"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                labelAlign="left"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Form.Item
                  name="name"
                  label="Nome"
                  rules={[
                    { required: true, message: "Por favor, insira o nome." },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Restaurante"
                    className="input-form-profile"
                  />
                </Form.Item>
                <Form.Item
                  name="address"
                  label="Endereço Completo"
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: "Por favor, insira o endereço.",
                    },
                  ]}
                >
                  <Input
                    placeholder="Avenida Luísa Todi N° 0 , 0000-000 Setúbal"
                    onChange={(e) => {
                      console.log("AQUI", e.target.value)
                      RestaurantService.getGeoLocationByAddress(e.target.value).then((res) => {
                        setClickedLocation({
                          lat: res.data[0].lat,
                          lng: res.data[0].lng
                        })
                      })
                    }}
                    onBlur={(e) => {
                      console.log("AQUI1", e.target.value)
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="contact"
                  label="Telefone"
                  style={{ width: "50%" }}
                  rules={[
                    {
                      required: true,
                      message: "Por favor, insira o telefone 1.",
                    },
                  ]}
                >
                  <Input
                    type="tel"
                    placeholder="123 456 789"
                    className="input-form-profile-minify"
                  />
                </Form.Item>
              </Form>
              <span className="title-resources-profile-text">
                Descrição do estabelecimento
              </span>
              <CharacterLimitedTextArea
                placeholder="Descrição do estabelecimento"
                maxLength={208}
                setDescription={setDescription}
                description={description}
              />
            </Flex>
            <Flex vertical style={
              {
                maxWidth: "90%",
                maxHeight: "100%",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "16px",
                margin: "16px",
                backgroundColor: "#fff",
                display: "flex",
              }
            }>
              <Flex vertical>
                <Alert
                  description="Para que possamos exibir seu restaurante ao usuário, necessitamos da sua geolocalização. Por favor, clique no ponto correspondente no mapa onde está localizado o seu estabelecimento, ou preencha manualmente com as coordenadas de latitude e longitude."
                  type="warning"
                  showIcon
                  style={{ marginBottom: '16px' }}
                />
                <Typography.Title level={3}>Registre a localização do seu Restaurante</Typography.Title>
              </Flex>
              <Flex vertical>
                <Flex vertical gap={20} style={{ marginBottom: '16px' }}>
                  <span style={{ marginRight: '8px' }}>Latitude:</span>
                  <Input
                    type="number"
                    placeholder="Digite a latitude"
                    value={clickedLocation ? clickedLocation.lat : ''}
                    onChange={(e) => setClickedLocation({ lat: parseFloat(e.target.value), lng: clickedLocation ? clickedLocation.lng : '' })}
                    style={{ width: '100%', marginRight: '16px' }}
                  />
                  <span style={{ marginRight: '8px' }}>Longitude:</span>
                  <Input
                    type="number"
                    placeholder="Digite a longitude"
                    value={clickedLocation ? clickedLocation.lng : ''}
                    onChange={(e) => setClickedLocation({ lat: clickedLocation ? clickedLocation.lat : '', lng: parseFloat(e.target.value) })}
                    style={{ width: '100%' }}
                  />
                </Flex>
                <Flex>
                </Flex>
                <Button
                  onClick={() => saveModifications()}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button-text-area"
                  style={{ width: "100%", backgroundColor: "#52c41a", borderColor: "#52c41a" }}
                >
                  Salvar e Continuar
                </Button>
              </Flex>
            </Flex>
          </Flex > :
          <Flex style={{
            maxWidth: "100vw",
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
            borderRadius: "10px",
            padding: "16px",
            margin: "16px",
          }}>
            <Flex vertical style={
              {
                maxWidth: "48%",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "16px",
                margin: "16px",
                backgroundColor: "#fff",
                display: "flex",
              }
            }>
              <Typography.Title level={4}>
                Cadastro de Restaurante
              </Typography.Title>
              <Alert
                description="Se porventura sair da página ou atualizar, o token para criar um restaurante será invalidado. Por conseguinte, solicite um novo token se necessário."
                type="warning"
                showIcon
                style={{ marginBottom: '16px' }}
              />
              <h3>Logo do Restaurante</h3>
              <UploadImages
                onDataReceived={handleDataReceivedImages}
                setImagesList={setImages}
                fileList={fileList}
                setFileList={setFileList}
              />
              <Form
                form={form}
                name="form"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                layout="vertical"
                labelAlign="left"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Form.Item
                  name="name"
                  label="Nome"
                  rules={[
                    { required: true, message: "Por favor, insira o nome." },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Restaurante"
                    className="input-form-profile"
                  />
                </Form.Item>
                <Form.Item
                  name="address"
                  label="Endereço Completo"
                  style={{ width: "100%" }}
                  rules={[
                    {
                      required: true,
                      message: "Por favor, insira o endereço.",
                    },
                  ]}
                >
                  <Input
                    placeholder="Avenida Luísa Todi N° 0 , 0000-000 Setúbal"
                    onBlur={(e) => {
                      RestaurantService.getGeoLocationByAddress(e.target.value).then((res) => {
                        console.log(res.data)
                        setClickedLocation({
                          lat: res.data.lat,
                          lng: res.data.lng
                        })
                      })
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        RestaurantService.getGeoLocationByAddress(e.target.value).then((res) => {
                          console.log(res.data)
                          setClickedLocation({
                            lat: res.data.lat,
                            lng: res.data.lng
                          })
                        })
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item
                  name="contact"
                  label="Telefone"
                  style={{ width: "50%" }}
                  rules={[
                    {
                      required: true,
                      message: "Por favor, insira o telefone 1.",
                    },
                  ]}
                >
                  <Input
                    type="tel"
                    placeholder="123 456 789"
                    className="input-form-profile-minify"
                  />
                </Form.Item>
              </Form>
              <span className="title-resources-profile-text">
                Descrição do estabelecimento
              </span>
              <CharacterLimitedTextArea
                placeholder="Descrição do estabelecimento"
                maxLength={208}
                setDescription={setDescription}
                description={description}
              />
            </Flex>
            <Flex vertical style={
              {
                maxWidth: "48%",
                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                borderRadius: "10px",
                padding: "16px",
                margin: "16px",
                backgroundColor: "#fff",
                display: "flex",
                overflow: "hidden"
              }
            }>
              <Flex vertical>
                <Alert
                  description="Para que possamos exibir seu restaurante ao usuário, necessitamos da sua geolocalização. Por favor, clique no ponto correspondente no mapa onde está localizado o seu estabelecimento, ou preencha manualmente com as coordenadas de latitude e longitude."
                  type="warning"
                  showIcon
                  style={{ marginBottom: '16px' }}
                />
                <Typography.Title level={3}>Registre a localização do seu Restaurante</Typography.Title>
              </Flex>
              <Flex vertical>
                <div style={{ marginBottom: '16px' }}>
                  <span style={{ marginRight: '8px' }}>Latitude:</span>
                  <Input
                    type="number"
                    placeholder="Digite a latitude"
                    value={clickedLocation ? clickedLocation.lat : ''}
                    onChange={(e) => setClickedLocation({ lat: parseFloat(e.target.value), lng: clickedLocation ? clickedLocation.lng : '' })}
                    style={{ width: '25%', marginRight: '16px' }}
                  />
                  <span style={{ marginRight: '8px' }}>Longitude:</span>
                  <Input
                    type="number"
                    placeholder="Digite a longitude"
                    value={clickedLocation ? clickedLocation.lng : ''}
                    onChange={(e) => setClickedLocation({ lat: clickedLocation ? clickedLocation.lat : '', lng: parseFloat(e.target.value) })}
                    style={{ width: '25%' }}
                  />
                </div>
                <Flex style={{
                  overflow: "hidden",

                }
                }>
                  <GoogleMap
                    clickedLocation={clickedLocation}
                    setClickedLocation={setClickedLocation}
                  />
                </Flex>
                <Flex>
                </Flex>
              </Flex>
              <Flex justify="end" style={{ marginTop: '16px' }}>
                <Button
                  onClick={() => saveModifications()}
                  type="primary"
                  htmlType="submit"
                  className="login-form-button-text-area"
                  style={{ width: "30%" }}
                >
                  Salvar e Continuar
                </Button>
              </Flex>
            </Flex>
          </Flex >
        }
      </Flex>
    </>
  );

  // Componente para Step 2: Vincular Conta
  const LinkAccountStep = () => (
    <Flex vertical style={{
      maxWidth: "100vw",
      boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
      borderRadius: "10px",
      padding: "16px",
      margin: "16px",
      justifyContent: "center",
      alignItems: "center",
    }}>
      <Divider style={{ width: "100%" }} />

      <Typography.Title level={4}>
        Login Social
      </Typography.Title>

      <Alert
        message="Restaurante criado com sucesso!"
        description="Para finalizar o processo, vincule sua conta com o Auth0. Isso permitirá que você faça login e gerencie seu restaurante."
        type="success"
        showIcon
        style={{ marginBottom: '16px', maxWidth: '600px' }}
      />

      <Button
        onClick={() => {
          const params = new URLSearchParams(window.location.search);
          const restaurantId = params.get('restaurantId');
          localStorage.setItem("@restaurantId", restaurantId);
          loginWithRedirect({
            appState: {
              // returnTo: `${window.location.origin}/create-restaurant-oauth/${uuid}${searchParams}`,
            },
            authorizationParams: {
              redirect_uri: `${window.location.origin}/create-restaurant-callback?restaurantId=${restaurantId}`,
            }
          });
        }}
        type="primary"
        htmlType="submit"
        className="login-form-button-text-area"
        style={{ width: "20%" }}
      >
        Vincular conta
      </Button>
    </Flex>
  );

  // Definição dos steps
  const steps = [
    {
      title: 'Dados do Restaurante',
      icon: <ShopOutlined />,
    },
    {
      title: 'Vincular Conta',
      icon: <UserOutlined />,
    }
  ];

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Typography.Title level={2} style={{ textAlign: 'center', marginBottom: '32px' }}>
        Criar Novo Restaurante
      </Typography.Title>
      
      <Steps
        current={currentStep}
        items={steps}
        style={{ marginBottom: '32px' }}
        responsive={false}
      />
      
      <div style={{ minHeight: '400px' }}>
        {currentStep === 0 && <RestaurantDataStep />}
        {currentStep === 1 && <LinkAccountStep />}
      </div>
    </div>
  );
}
